<template>
  <div class="deviceAlarmRule">
    <div class="title">
      <p>
        <span>离线规则</span>
      </p>
    </div>
    <!--列表-->
    <div class="content">
      <div class="contain">
        <!--新增规则-->
        <el-button class="addBtn" type="primary" @click="addClick">
          <el-icon>
            <Plus/>
          </el-icon>
          新增规则
        </el-button>
        <!--规则列表-->
        <el-table v-loading="loading" :data="tableData" style="width: 100%">
          <template #empty>
            <el-empty class="emptyClass" description="暂无数据信息"
                      image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
            </el-empty>
          </template>
          <el-table-column label="规则名称" prop="name"></el-table-column>
          <el-table-column label="告警阈值" prop="threshold"></el-table-column>
          <el-table-column label="是否发送短信" prop="sendSmsFlagStr"></el-table-column>
          <el-table-column label="创建时间" prop="createTime"></el-table-column>
          <el-table-column label="最近触发时间" prop="lastTriggerTime"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160px">
            <template #default="scope">
              <div class="opacity">
                <span class="editClass btn" @click.prevent="lookLog(scope.row.id,scope.row)">日志</span>
                <span class="editClass btn" @click.prevent="editClick(scope.row.id,scope.row)">编辑</span>
                <span class="editClass delBtn" @click.prevent="delClick(scope.row.id,scope.row)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="tableData.length>0" class="pag">
          <el-pagination v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="total" background
                         layout="total,sizes,prev, pager, next" @size-change="handleSizeChange"
                         @current-change="pageChange"/>
        </div>
      </div>
    </div>
    <!--新增编辑弹窗-->
    <el-dialog v-model="dialogFormVisible" :close-on-click-modal="false" :title="formData.id?'编辑规则':'新建规则'"
               style="min-width: 1008px" width="70%">
      <el-form ref="fromRef" :inline="true" :model="formData" :rules="formRules">
        <el-form-item label="规则名称:" prop="name">
          <el-input v-model="formData.name" placeholder="请输入规则名称"></el-input>
        </el-form-item>
        <el-form-item class="topFormItem topFormItem2" label="设备" prop="equipmentIdList" style="width: 100%">
          <el-select ref="elSelectTable" v-model="formData.equipmentIdList1"
                     :disabled="true" :popper-append-to-body="false" :suffix-icon="Plus"
                     class="timeSelect" multiple popper-class="timeSelectPopper"
                     @click="selectTimeFun">
            <el-option v-for="(item,index) in formData.equipmentIdList" :key="index"
                       :label="item.value"
                       :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="告警阈值(分钟):" prop="threshold" style="width: calc(100% - 32px)">
          <el-input-number v-model.number="formData.threshold" :max="10000" :min="0" placeholder="请输入告警阈值"
                           type="number"
          >
            <template #suffix>分钟</template>
          </el-input-number>
        </el-form-item>
        <!--新增-->
        <p class="line" style="width: 100%;height: 1px;background-color: #eee;margin-bottom: 25px"></p>
        <el-form-item label="是否发送短信:" prop="sendSmsFlag" style="width: calc(100% - 32px)">
          <el-switch v-model="formData.sendSmsFlag"></el-switch>
        </el-form-item>
        <el-form-item label="通知用户:" prop="item.mobile">
          <!--          <el-select v-model="formData.user" multiple placeholder="请选择通知用户">-->
          <!--            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"/>-->
          <!--          </el-select>-->
          <el-select ref="elSelectTable" v-model="formData.memberIds1" :disabled="true"
                     :popper-append-to-body="false" :suffix-icon="Plus" class="timeSelect"
                     multiple popper-class="timeSelectPopper" style="width: 500px"
                     @click="selectTimeFun2">
            <el-option v-for="(item,index) in formData.memberIds" :key="index"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
          <UserCheck :checkDeviceList="formData.memberIds" :deviceVisible="deviceVisible2" :isMultiple="true"
                     @checkDeviceListFun="checkDeviceListFun2" @deviceVisibleFun="deviceVisibleFun2"/>
        </el-form-item>
        <div v-for="(item,index) in formData.mobiles" :key="index" class="notificationBox" style="width: 100%">
          <el-form-item :prop="'mobiles.' + index + '.number'" :rules="phoneRules" label="通知人手机号:">
            <el-input v-model="item.number" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-icon v-if="formData.mobiles.length>1" class="delIcon"
                   style="font-size: 18px;margin-right: 5px;cursor: pointer;transform: translateY(-2px)"
                   @click="notificationDelClick(index)">
            <CircleClose/>
          </el-icon>
          <el-icon v-if="index===formData.mobiles.length-1"
                   class="addIcon" style="font-size: 18px;margin-right: 5px;cursor: pointer;transform: translateY(-2px)"
                   @click="notificationAddClick">
            <CirclePlus/>
          </el-icon>
        </div>
        <p class="line" style="width: 100%;height: 1px;background-color: #eee;margin-bottom: 25px"></p>

      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button class="cancle" @click="dialogFormVisible=false">取消</el-button>
        <el-button class="confrim" type="primary" @click="save()">保存</el-button>
      </span>
      </template>
    </el-dialog>
    <!--查看日志弹窗-->
    <el-dialog v-model="dialogFormVisible2" :close-on-click-modal="false" style="min-width: 1008px"
               title="查看日志" width="70%">
      <!--规则列表-->
      <el-table v-loading="loading" :data="logList" style="width: 100%">
        <template #empty>
          <el-empty class="emptyClass" description="暂无数据信息"
                    image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
          </el-empty>
        </template>
        <el-table-column label="设备名称" prop="equipmentName"></el-table-column>
        <el-table-column label="离线时间" prop="createTime" sortable></el-table-column>
      </el-table>
      <div v-if="logList.length>0" class="pag" style="margin-top: 20px;display: flex;justify-content: end">
        <el-pagination v-model:page-size="pageSize2" :page-sizes="[10, 20, 50, 100]" :total="logTotal" background
                       layout="total,sizes,prev, pager, next" @size-change="handleSizeChange2"
                       @current-change="pageChange2"/>
      </div>
      <template #footer>
      <span class="dialog-footer">
        <el-button class="cancle" @click="dialogFormVisible2=false">确定</el-button>
      </span>
      </template>
    </el-dialog>
    <DeviceSelect :checkDeviceList="formData.equipmentIdList" :deviceVisible="deviceVisible"
                  @checkDeviceListFun="checkDeviceListFun" @deviceVisibleFun="deviceVisibleFun"/>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {h, onMounted, ref, watch} from "vue"
import './deviceAlarmRule.less'
import DeviceSelect from '@/components/deviceSelect'
import UserCheck from './userCheck'

import {CircleClose, CirclePlus, Plus} from '@element-plus/icons-vue'
import {ElMessage, ElMessageBox} from 'element-plus'
import {useRouter} from 'vue-router';
import qs from "qs";
import {getAllTreeApi} from "@/api/modules/strategy";
import {
  addEquipmentOfflineRuleApi,
  delEquipmentOfflineRuleApi,
  getAlarmSelectListAPi,
  getEquipmentOfflineLogApi,
  getEquipmentOfflineRuleApi,
  getEquipmentOfflineRuleDetailApi,
  getUserSelectListAPi
} from "@/api/modules/alarm";

let router = useRouter()

let userList = ref([])


// 规则列表-----------------------------------------------------------------
// 分页
let pageNumber = ref(1)
let pageSize = ref(20)
let total = ref(0)
// 更改每页多少
const handleSizeChange = function (e) {
  pageSize.value = e
  getListFun()
}
// 跳转到某页
const pageChange = function (e) {
  pageNumber.value = e
  getListFun()
}
// 表格数据
let tableData = ref([])
// 获取表格数据
let loading = ref(false)
const getListFun = function () {
  loading.value = true
  getEquipmentOfflineRuleApi(qs.stringify({
    pageNumber: pageNumber.value,
    pageSize: pageSize.value
  })).then(res => {
    loading.value = false
    if (res.data.code === 0) {
      tableData.value = res.data.result.list
      total.value = Number(res.data.result.total)
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


// 查看日志
let logList = ref([])
let logTotal = ref(0)
// 获取规则日志方法
let pageNumber2 = ref(1)
let pageSize2 = ref(20)
const getEquipmentOfflineLogFun = function () {
  getEquipmentOfflineLogApi(qs.stringify({
    pageNumber: pageNumber2.value,
    pageSize: pageSize2.value,
    ruleId: ruleId.value
  })).then(res => {
    if (res.data.code === 0) {
      logList.value = res.data.result.list
      logTotal.value = Number(res.data.result.total)
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 更改每页多少
const handleSizeChange2 = function (e) {
  pageSize2.value = e
  getEquipmentOfflineLogFun()
}
// 跳转到某页
const pageChange2 = function (e) {
  pageNumber2.value = e
  getEquipmentOfflineLogFun()
}
let dialogFormVisible2 = ref(false)
let ruleId = ref()
const lookLog = function (id) {
  ruleId.value = id
  dialogFormVisible2.value = true
  pageNumber2.value = 1
  pageSize2.value = 20
  getEquipmentOfflineLogFun()
}


// 新增编辑-----------------------------------------------------------------
// 新增编辑弹窗
let dialogFormVisible = ref(false)
// 新增编辑表单数据
let formData = ref({
  id: 0,
  name: '',
  equipmentIdList: [],
  memberIds1: [],
  memberIds: [],
  sendSmsFlag: true,
  threshold: 5,
  mobiles: [{
    number: ''
  }]
})
// 表单规则
let formRules = ref({
  name: [
    {required: true, message: '请输入规则名称', trigger: 'blur'},
  ],
  threshold: [
    {required: true, message: '请输入告警阈值', trigger: 'blur'},
  ],
  equipmentIdList: [
    {
      type: 'array',
      required: true,
      min: 1,
      message: '请选择设备',
      trigger: 'blur'
    }
  ]
})
// 手机号验证规则
const validatePhone = (rule, value, callback) => {
  if (!value) {
    // return callback(new Error('请输入手机号'));
    callback();
  }
  if (!/^1[3-9]\d{9}$/.test(value)) {
    return callback(new Error('请输入正确的手机号'));
  }
  callback();
};
let phoneRules = ref([
  {validator: validatePhone, trigger: 'blur'}
])
// 点击新增
const addClick = function () {
  dialogFormVisible.value = true
  formData.value = {
    id: 0,
    name: '',
    equipmentIdList: [],
    memberIds1: [],
    memberIds: [],
    sendSmsFlag: true,
    threshold: 5,
    mobiles: [{
      number: ''
    }]
  }
}
// 点击编辑
const editClick = function (id, row) {
  dialogFormVisible.value = true
  getEquipmentOfflineRuleDetailApi(qs.stringify({id: id})).then(res => {
    if (res.data.code === 0) {
      formData.value = {
        id: res.data.result.id,
        name: res.data.result.name,
        equipmentIdList1: res.data.result.equipmentIdList,
        memberIds1: res.data.result.memberIdList,
        sendSmsFlag: res.data.result.sendSmsFlag == 1 ? true : false,
        threshold: res.data.result.threshold,
      }
      let data = JSON.parse(JSON.stringify(res.data.result))
      formData.value.equipmentIdList = []
      let equipmentNames = data.equipmentNames.split(",")
      for (let i = 0; i < data.equipmentIdList.length; i++) {
        formData.value.equipmentIdList.push({
          value: equipmentNames[i],
          key: data.equipmentIdList[i]
        })
      }
      formData.value.memberIds = []
      let memberNames = data.memberNames.split(",")
      for (let i = 0; i < data.memberIdList.length; i++) {
        formData.value.memberIds.push({
          id: data.memberIdList[i],
          name: memberNames[i]
        })
      }
      if (data.mobileList.length === 0) {
        formData.value.mobiles = [{
          number: ''
        }]
      } else {
        formData.value.mobiles = []
        for (let i = 0; i < data.mobileList.length; i++) {
          formData.value.mobiles.push({
            number: data.mobileList[i]
          })
        }
      }
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 点击新增通知人手机号
const notificationAddClick = function () {
  formData.value.mobiles.push({
    number: ''
  })
}
// 点击删除通知人
const notificationDelClick = function (index) {
  formData.value.mobiles.splice(index, 1)
}
// 提交
let fromRef = ref()
const save = function () {
  // 提交表单
  if (fromRef) {
    fromRef.value.validate((valid) => {
      //提交成功
      if (valid) {
        let data = JSON.parse(JSON.stringify(formData.value))
        data.equipmentIds = data.equipmentIdList1.join(',')
        data.memberIds = data.memberIds1.join(',')
        data.sendSmsFlag = data.sendSmsFlag ? 1 : 0
        for (let i = 0; i < data.mobiles.length; i++) {
          if (!data.mobiles[i].number && data.mobiles[i].number === '') {
            data.mobiles.splice(i, 1)
          }
        }
        data.mobiles = data.mobiles.filter(item => item);
        data.mobiles = data.mobiles.map(item => item.number)
        data.mobiles = data.mobiles.join(',')
        delete data.equipmentIdList1
        delete data.memberIds1
        addEquipmentOfflineRuleApi(qs.stringify(data)).then(res => {
          if (res.data.code === 0) {
            getListFun()
            dialogFormVisible.value = false
          } else {
            ElMessage({
              type: 'error',
              message: res.data.message
            })
          }
        }).catch(err => {
          console.log(err);
        })
      }
    })
  }
}


// 设备选择-----------------------------------------------------------------
let deviceVisible = ref(false)
const selectTimeFun = function () {
  deviceVisible.value = true
}
const deviceVisibleFun = function (data) {
  deviceVisible.value = data
}
const checkDeviceListFun = function (data) {
  formData.value.equipmentIdList = data
}
watch(() => formData.value.equipmentIdList, (newVal) => {
  formData.value.equipmentIdList1 = []
  for (let i = 0; i < newVal.length; i++) {
    formData.value.equipmentIdList1.push(newVal[i].key)
  }
}, {deep: true, immediate: true})


// 用户选择-----------------------------------------------------------------
let deviceVisible2 = ref(false)
const selectTimeFun2 = function () {
  deviceVisible2.value = true
}
const deviceVisibleFun2 = function (data) {
  deviceVisible2.value = data
}
const checkDeviceListFun2 = function (data) {
  formData.value.memberIds = data
}
watch(() => formData.value.memberIds, (newVal) => {
  formData.value.memberIds1 = []
  for (let i = 0; i < newVal.length; i++) {
    formData.value.memberIds1.push(newVal[i].id)
    if (newVal[i].mobile && !formData.value.mobiles.some((item) => item.number === newVal[i].mobile)) {
      formData.value.mobiles.unshift({
        number: newVal[i].mobile
      })
    }
  }
}, {deep: true, immediate: true})


// 点击删除-----------------------------------------------------------------
const delClick = function (id, row) {
  ElMessageBox.confirm('请确认是否要删除此离线规则，删除后数据不可恢复', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除规则',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }, ''),
      h('span', {style: 'color:#595959;'}, '请确认是否要删除此离线规则，删除后数据不可恢复'),
    ])
  }).then(() => {
    delEquipmentOfflineRuleApi(qs.stringify({id: id})).then(res => {
      if (res.data.code === 0) {
        getListFun()
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '已取消删除'
    });
  });
}


// 树形结构-----------------------------------------------------------------
let treeRef1 = ref()
// 筛选树形结构唯一值
const onlySelect = function (data) {
  for (let i = 0; i < data.length; i++) {
    if (data[i].type == 1) {
      data[i].id = data[i].id + '_' + data[i].type
    }
    // data[i].onlyValue = data[i].id + '_' + data[i].type
    if (data[i].subList.length > 0) {
      onlySelect(data[i].subList)
    }
  }
}
// 项目树配置
let props = {
  label: 'name',
  value: 'id',
  children: 'subList',
  disabled: 'isProject',
  isLeaf: (data, node) => {
    if (node.data.type === 2) {
      return true
    }
  }
}
// 树形结构数据
let allTree = ref()
let selectList = ref([])
let memberList = ref([])

onMounted(() => {
  getListFun()

  // 获取所有设备树
  getAllTreeApi().then(async res => {
    if (res.data.code === 0) {
      let data = res.data.result
      await onlySelect(data)
      allTree.value = data
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  })

  // 获取告警模版选项
  getAlarmSelectListAPi().then(async res => {
    if (res.data.code === 0) {
      selectList.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  })
  // 获取登陆组织的用户选项
  getUserSelectListAPi().then(async res => {
    if (res.data.code === 0) {
      memberList.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  })
})


</script>

<style lang="less">
.topFormItem2 {
  .el-select .el-select__wrapper.is-disabled, .el-select .el-icon.el-select__caret.el-select__icon {
    cursor: pointer !important;
  }
}
</style>
